export default __webpack_public_path__ + "static/media/signature-steven-rosato-primary.e7967349.svg";